module.exports = __webpack_public_path__ + "img/childCard.209c496a.png";